import { registerBrowserRoutes } from '@zg-rentals/route-list';

const base = 'renter-hub';
const concatParams = (queryString = null, url, encode = false) => {
  if (!queryString) {
    return url.split('?')[0];
  }

  if (encode) {
    return url + encodeURIComponent(queryString);
  } else {
    return url + queryString;
  }
};

const pathsManifest = {
  base: `/${base}`,
  dashboard: `/${base}`,
  termsPage: `/${base}/terms`,

  // All feedback pages have been deprecated and redirected to zillow.com/renting
  inquiryFeedbackPage: `/${base}/response-feedback`,
  inquiryFeedbackSuccessPage: `/${base}/response-feedback/success`,
  tourFeedbackPage: `/${base}/tour-feedback`,
  tourFeedbackSuccessPage: `/${base}/tour-feedback/success`,
  moveInFeedbackPage: `/${base}/move-in-feedback/survey`,
  moveInFeedbackSuccessPage: `/${base}/move-in-feedback/success`,

  // All property review pages have been deprecated and redirected to zillow.com/renting
  propertyReviewGuidelinesPage: `/${base}/property-review-guidelines`,
  propertyRatingAndReviewBase: `/${base}/property-review/*`,
  propertyRatingAndReviewRatePage: `/${base}/property-review/rate`,
  propertyRatingAndReviewCommentPage: `/${base}/property-review/comment`,
  propertyRatingAndReviewManagerPage: `/${base}/property-review/manager`,
  propertyRatingAndReviewManagerCommentPage: `/${base}/property-review/manager/comment`,
  propertyRatingAndReviewSuccessPage: `/${base}/property-review/thanks`,
  propertyRatingAndReviewTenantPage: `/${base}/property-review/tenant`,

  zillowPaymentsUrl: `/${base}/payments`,

  nativeAppSignInPage: `/${base}/nativeAppSignInPage`,
  paymentsPage: `/${base}/payments`,
  applicationsPage: `/${base}/applications`,
  screeningPages: `/${base}/screening`,
  inboxPage: `/${base}/inbox`,

  authenticatedTestPage: `/${base}/authenticated-test`,
  unauthenticatedTestPage: `/${base}/unauthenticated-test`,
  strongAuthenticatedTestPage: `/${base}/strongauthenticated-test`,

  ipCheckPage: `/${base}/ip`,

  waitlistConfirmationPage: `/${base}/response-waitlist`,

  signInPage: {
    hotpads: (queryString) => concatParams(queryString, '/login?redirect='),
    trulia: (queryString) => concatParams(queryString, '/login/r'),
    zillow: (queryString) => concatParams(queryString, '/user/acct/login/?url=', true),
  },

  logOutPage: {
    hotpads: '/logout',
    trulia: '/logout/',
    zillow: '/Logout.htm',
  },
};

registerBrowserRoutes(pathsManifest);

export default pathsManifest;
